import { getSmileSimulationProgressLabel } from "../lib/progress";
import { SMILE_SIMULATION_PROGRESS_CIRCLE_CIRCUMFERENCE } from "./constants";
import type { SmileSimulationState } from "./state";

export const selectIsCameraVisible = (state: SmileSimulationState) =>
  state.step !== "login";

export const selectIsCaptured = (state: SmileSimulationState) =>
  state.step === "result";

export const selectHasEmail = (state: SmileSimulationState) =>
  Boolean(state.auth.email.trim());

export const selectIsCaptureDisabled = (state: SmileSimulationState) =>
  state.step !== "capture" || state.camera.status !== "ready";

export const selectIsSimulationProcessing = (state: SmileSimulationState) =>
  state.simulation.status === "processing";

export const selectHasComparisonResult = (state: SmileSimulationState) =>
  Boolean(state.capture.image && state.simulation.resultImage);

export const selectSimulationProgressLabel = (state: SmileSimulationState) =>
  getSmileSimulationProgressLabel(state.simulation.progress);

export const selectSimulationProgressOffset = (state: SmileSimulationState) =>
  SMILE_SIMULATION_PROGRESS_CIRCLE_CIRCUMFERENCE *
  (1 - state.simulation.progress / 100);

export const selectFooterMessage = (state: SmileSimulationState) => {
  if (state.step !== "result") {
    return "";
  }

  if (state.simulation.status === "completed") {
    return "전후 이미지를 드래그해서 비교해 보세요.";
  }

  if (state.simulation.status === "processing") {
    return selectSimulationProgressLabel(state);
  }

  return state.simulation.message || "사진을 분석하고 있어요.";
};
